import { render, staticRenderFns } from "./ExchangeAmount.vue?vue&type=template&id=4cc93d72&"
import script from "./ExchangeAmount.vue?vue&type=script&lang=ts&"
export * from "./ExchangeAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports